const HisAlertCircle = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg style={_sx} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.375 21.8281C16.8978 21.8281 21.375 17.351 21.375 11.8281C21.375 6.30528 16.8978 1.82812 11.375 1.82812C5.85215 1.82812 1.375 6.30528 1.375 11.8281C1.375 17.351 5.85215 21.8281 11.375 21.8281Z"
        stroke={strokeColor}
        strokeWidth="1.87826"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.375 7.82812V11.8281"
        stroke={strokeColor}
        strokeWidth="1.87826"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.375 15.8203H11.384"
        stroke={strokeColor}
        strokeWidth="1.87826"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisAlertCircle;
